import { MatStepper } from '@angular/material/stepper'

export const resetSteps = (stepper: MatStepper): void =>
    stepper.steps.forEach((step) => step.reset())
